<div class="app-content">
  <div class="routed-content">
    <router-outlet></router-outlet>
  </div>
</div>
<app-spinner></app-spinner>
